import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  ColumnListResponseSchema,
  ColumnTypeEnum,
  FilterOptionsQuerySchema,
  FilterOptionsRequestSchema,
  FilterOptionsResponseSchema,
  PlanListQuerySchema,
  PlanListRequestSchema,
  PlanListResponseSchema,
  PlanTotalsQuerySchema,
  PlanTotalsRequestSchema,
  PlanTotalsResponseSchema,
  UpdateUserSettingsRequestSchema,
  UserSettingsResponseSchema,
} from '../shared/schemas/myPlans.js';

export type PlanListRequest = z.infer<typeof PlanListRequestSchema>;
export type PlanListResponse = z.infer<typeof PlanListResponseSchema>;
export type ColumnListResponse = z.infer<typeof ColumnListResponseSchema>;
export type ColumnTypes = z.infer<typeof ColumnTypeEnum>;
export type {
  FilterParams,
  ComparisonOperatorType,
  TextFilterConditionType,
  NumberFilterConditionType,
  FilterOptionsResponse,
  PlanTotalsRequest,
  PlanTotalsResponse,
  PlanTotalsWarning,
  UserSettingsResponse,
  UpdateUserSettingsRequest,
} from '../shared/schemas/myPlans.js';

export const getPlanListQueryOptions = defaultClient.query({
  url: 'planning-service/my-plans/' as const,
  method: 'POST',
  responseSchema: PlanListResponseSchema,
  requestSchema: PlanListRequestSchema,
  querySchema: PlanListQuerySchema,
  processResponse(data) {
    return data;
  },
});

export const getColumnListQueryOptions = defaultClient.query({
  url: 'planning-service/my-plans/columns/' as const,
  method: 'GET',
  responseSchema: ColumnListResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const getFilterOptionsQueryOptions = defaultClient.query({
  url: 'planning-service/my-plans/filter-options/',
  method: 'POST',
  requestSchema: FilterOptionsRequestSchema,
  querySchema: FilterOptionsQuerySchema,
  responseSchema: FilterOptionsResponseSchema,
});

export const getPlanTotalsQueryOptions = defaultClient.query({
  url: 'planning-service/my-plans/totals/' as const,
  method: 'POST',
  responseSchema: PlanTotalsResponseSchema,
  requestSchema: PlanTotalsRequestSchema,
  querySchema: PlanTotalsQuerySchema,
  processResponse(data) {
    return data;
  },
});

export const getUserSettingsQueryOptions = defaultClient.query({
  url: 'planning-service/my-plans/settings/',
  method: 'GET',
  responseSchema: UserSettingsResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const updateUserSettings = defaultClient.mutation({
  url: 'planning-service/my-plans/settings/update/',
  method: 'POST',
  requestSchema: UpdateUserSettingsRequestSchema,
  responseSchema: UserSettingsResponseSchema,
  processResponse(data) {
    return data;
  },
});
